var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-none flex items-center justify-center"},[_c('div',_vm._g({staticClass:"margin-one flex flex-row text-base hover:no-underline border border-solid rounded-md py-2 px-5 cursor-pointer",class:{'hover-active': _vm.hover},style:({
      color: _vm.button.fontColor,
      'font-family': _vm.survey.fontFamily,
      'background-color': _vm.button.bgColor,
      'border-color': _vm.button.borderColor,
    }),domProps:{"textContent":_vm._s(_vm.buttonText)},on:{"mouseover":function($event){_vm.hover=true},"mouseleave":function($event){_vm.hover=false}}},_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }